import Vue from 'vue'
import ClickOutside from '@/directives/clickOutside'

// Add custom directives
Vue.directive("click-outside", ClickOutside)
